class Writer {
  write() {
    throw Error('Writer.write() must be implemented')
  }
}

export default Writer
